import classnames from 'classnames'
import Button from '@components/Button'

const Pillbox = props => {
  const { value, label, title, isActive, onClick } = props
  const handleClick = e => {
    onClick(value)
  }
  const classNames = classnames('button-reset pillbox', { 'pillbox--active': isActive })
  return (
    <Button aria-label={label} title={title} className={classNames} onClick={handleClick} disabled={isActive}>
      {label}
    </Button>
  )
}

export default Pillbox
